import React, { Component } from 'react';
import getLocale from '../../../i18n/getLocale';
class SchedulesElaborateBasesTotal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      show: this.props.show,
      data: this.props.data,
      schedule: this.props.schedule,
    };

    this.locale = getLocale();
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.schedule.name !== 'undefined')) {
      this.setState({
        schedule: newProps.schedule,
        data: newProps.data,
        loaded: 1,
      });
    }
  }

  

  render() {
    var self = this;
    return (
<div>
  <h3>{this.locale.Escalas.ElaboracaoDeEscala.tabTotaisDoPeriodo.tituloEscalaDe} {self.state.schedule['name']} - {self.state.schedule['aircraft_model']['model']}</h3>
  <hr/>
  <div className="listing table-responsive">
    <table className="table table-bordered table-striped table-hover">
      <thead>
        <tr>
          <th>{this.locale.Escalas.ElaboracaoDeEscala.tabTotaisDoPeriodo.tabela.Nome}</th>
          <th>{this.locale.Escalas.ElaboracaoDeEscala.tabTotaisDoPeriodo.tabela.TotalAno}</th>
          <th>{this.locale.Escalas.ElaboracaoDeEscala.tabTotaisDoPeriodo.tabela.TotalGeral}</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(self.state.data).map(function(s) {
          return (
            <tr>
              <td>{self.state.data[s]["name"]}</td>
              <td>{self.state.data[s]["total_ano"]}</td>
              <td>{self.state.data[s]["total_geral"]}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
</div>
    );
  }
}

export default SchedulesElaborateBasesTotal;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/SchedulesElaborateBasesTotal.js